// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__FUoYC","inline":"Label_inline__23Cuh","reverse":"Label_reverse__2_dxN","justify":"Label_justify__3lVdn","text":"Label_text__12YNL"};